var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon"},[_c('img',{attrs:{"src":require(("@/assets/img/icons/download-icons/" + _vm.icon)),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }